import {makeStyles, styled} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import Box from "@material-ui/core/Box";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {ADD_NOTIFICATION} from "../store/action";
import React, {useMemo} from "react";
import EventNoteIcon from '@material-ui/icons/EventNote';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import TorListItem from "./TorListItem";
import {connect} from "react-redux";
import ButtonBase from "@material-ui/core/ButtonBase";
import ShareIcon from '@material-ui/icons/Share';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PersonIcon from '@material-ui/icons/Person';
import User from './bookingWizard/steps/user.png'

export const StyledImage = styled(Box)((props) => ({
    backgroundImage: `url(${props.src})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    height: '140px',
    width: '100%',
    maxWidth: '500px',
}))

const useLoggedMenuStyles = makeStyles((theme) => ({
    root: {
        width: '100vw',
        height: '100vh',
        maxWidth: '600px',
        backgroundColor: theme.palette.background,
        boxSizing: 'border'
    },
    coverPhoto: {
        height: '150px',
        overflow: 'hidden',
        backgroundColor: theme.palette.disabledColor,
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    profilePhoto: {},
    topPart: {
        color: theme.palette.secondary.main,
        display: 'flex',
        flexDirection: 'column',
        borderBottom: '1px solid #7070703d',
        paddingBottom: theme.spacing(2),
        margin: theme.spacing(2),
    },
    middlePart: {
        display: 'flex',
        justifyContent: 'space-around',
        paddingBottom: theme.spacing(3)
    },
    action: {
        display: 'flex',
        gap: theme.spacing(0.5),
        fontSize: '14px',
        color: theme.palette.secondary.main,
        opacity: 0.8
    },
    list: {
        padding: '0 16px'
    }

}));

const LoggedInMenu = ({toggleDrawer, dispatch, history, shortHash, fullName, address, image}) => {
    const classes = useLoggedMenuStyles()
    const {t} = useTranslation()
    const activePath = history?.location?.pathname
    const linkToBook = useMemo(() => {
        const arr = window.location.href.split('/')
return `${arr[0]}//${shortHash}.${arr[2]}`
    }, [shortHash])

    return <div
        className={classes.root}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
    >
        <div className={classes.coverPhoto}><StyledImage src={image}/></div>
        <div className={classes.topPart}>
            <Box textAlign={'right'}><CloseIcon color={'secondary'}/></Box>
            <Typography variant="subtitle1" color={'secondary'} align={'center'}>{fullName}</Typography>
            <Typography variant={'subtitle2'} textAlign={'center'} align={'center'}>{address}</Typography>
        </div>
        <div className={classes.middlePart}>
            <ButtonBase className={classes.action} onClick={() => navigator.share({url: linkToBook})}>
                <ShareIcon fontSize={'inherit'} color={'secondary'}/>
                <div>{t('share_page')}</div>
            </ButtonBase>
            <ButtonBase className={classes.action} onClick={() => history.push('/edit-supplier')}>
                <EditIcon fontSize={'inherit'} color={'secondary'}/>
                <div>{t('edit_profile')}</div>
            </ButtonBase>
            <ButtonBase className={classes.action} onClick={() => {
                window.location.href = linkToBook;
            }}>
                <VisibilityIcon fontSize={'inherit'} color={'secondary'}/>
                <div>{t('show_page')}</div>
            </ButtonBase>
        </div>
        <List className={classes.list}>
            <TorListItem onClick={() => history.push("/calendar")}
                         selected={activePath === '/calendar'}
                         icon={<EventNoteIcon/>}
                         text={t('schedule')}/>

            <TorListItem onClick={() => history.push("/personal-details")}
                         selected={activePath === '/personal-details'}
                         icon={<PersonIcon/>}
                         text={t('personal_details')}/>

            <TorListItem onClick={() => {
                firebase.auth().signOut().then(function () {
                }).catch(function (error) {
                    dispatch({
                        type: ADD_NOTIFICATION,
                        payload: {
                            type: 'error',
                            text: t('cant-logout')
                        }
                    })
                });
            }}
                         icon={<ExitToAppIcon/>}
                         text={t('logout')}/>
        </List>
    </div>
}

const mapStateToProps = state => ({
    isAuthenticated: state.general.auth,
    shortHash: state.general?.supplier?.personalData?.shortHash,
    fullName: state.general?.supplier?.personalData?.fullName,
    address: state.general?.supplier?.personalData?.address?.title || '',
    image: state.general?.supplier?.personalData?.images[0]?.url || User,
})

export default connect(mapStateToProps)(LoggedInMenu)